export const WELCOME_MESSAGE = "Welcome to API Nexus.";
